// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnActionGroup {
  gap: 12px;
}

/* =========================================================
   COLLAPSE CARD
   ========================================================= */
.collapse-card {
  --collapse-accent: #88b6f2;
  position: relative;
  border-radius: var(--radius, 8px);
  overflow: hidden;
  min-width: 0;
  /* Gap between each collapse bar */
  margin-bottom: 20px;
  margin-top: 14px;
  /* Force white background */
  background: #ffffff;
  transition: box-shadow 150ms ease, transform 150ms ease;
}

/* Remove extra gap from the last collapse card */
.collapse-card:last-child {
  margin-bottom: 0;
}

/* ---- LEFT ACCENT BAR ---- */
.collapse-card::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 6px;
  background: var(--collapse-accent);
  border-radius: 10px 0 0 10px;
  z-index: 2;
  pointer-events: none;
}

/* ---- HOVER ---- */
.collapse-card:hover {
  box-shadow: 0 4px 14px rgba(136, 182, 242, 0.25);
}

.collapse-card:hover::before {
  background: var(--collapse-accent);
}

/* ---- HEADER ---- */
.collapse-card-header {
  background: #ffffff;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  /* Extra left padding for accent bar */
  padding: 12px 20px 12px 28px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  z-index: 1;
}

/* ---- HEADER RIGHT ---- */
.collapse-card-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ---- TITLE ---- */
.collapse-card-title {
  flex: 1 1 auto;
  min-width: 0;
}

.collapse-card-title h5 {
  margin: 0;
  font-size: 17px;
  font-weight: 750;
  color: var(--navy);
}

/* ---- TOGGLE ICON ---- */
.collapse-card-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted);
  cursor: pointer;
  transition: color 150ms ease, background 150ms ease;
}

.collapse-card-icon:hover {
  background: transparent;
  border-color: transparent;
  color: var(--collapse-accent);
}

.collapse-card-icon svg {
  transition: transform 0.28s ease;
}

.collapse-card.open .collapse-card-icon svg {
  transform: rotate(0deg);
}

.collapse-card:not(.open) .collapse-card-icon svg {
  transform: rotate(-90deg);
}

/* ---- COLLAPSIBLE CONTENT ---- */
.collapse-card-content {
  background: #ffffff;
  display: grid;
  grid-template-rows: 1fr;
  opacity: 1;
  overflow: hidden;
  transition: grid-template-rows 0.28s ease, opacity 0.22s ease;
}

.collapse-card.open .collapse-card-content {
  grid-template-rows: 1fr;
  opacity: 1;
}

.collapse-card:not(.open) .collapse-card-content {
  grid-template-rows: 0fr;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

/* ---- CARD BODY ---- */
.collapse-card-content > .card-body {
  background: #ffffff;
  min-height: 0;
  overflow: hidden;
  /* Clear left accent bar */
  padding-left: 20px;
}

.collapse-card-content .row {
  min-width: 0;
}

/* =========================================================
   RESPONSIVE
   ========================================================= */
@media (max-width: 760px) {
  .collapse-card {
    margin-bottom: 12px;
  }
  .collapse-card-header {
    min-height: 60px;
    padding: 12px 16px 12px 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Collapsecard/collapseCard.scss"],"names":[],"mappings":"AAoLA;EACE,SAAA;AAnLF;;AAsLA;;8DAAA;AAIA;EACE,0BAAA;EAEA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,YAAA;EAEA,kCAAA;EACA,mBAAA;EACA,gBAAA;EAEA,2BAAA;EACA,mBAAA;EACA,uDACE;AAxLJ;;AA4LA,iDAAA;AACA;EACE,gBAAA;AAzLF;;AA4LA,8BAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,kCAAA;EACA,4BAAA;EACA,UAAA;EACA,oBAAA;AAzLF;;AA4LA,oBAAA;AACA;EACE,gDAAA;AAzLF;;AA4LA;EACE,kCAAA;AAzLF;;AA4LA,qBAAA;AACA;EACE,mBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,SAAA;EAEA,sCAAA;EACA,4BAAA;EAEA,eAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,kBAAA;EACA,UAAA;AA9LF;;AAiMA,2BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA9LF;;AAiMA,oBAAA;AACA;EACE,cAAA;EACA,YAAA;AA9LF;;AAiMA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA9LF;;AAiMA,0BAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EAEA,UAAA;EACA,SAAA;EACA,uBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,eAAA;EAEA,mDACE;AAnMJ;;AAuMA;EACE,uBAAA;EACA,yBAAA;EACA,6BAAA;AApMF;;AAuMA;EACE,gCAAA;AApMF;;AAuMA;EACE,uBAAA;AApMF;;AAuMA;EACE,yBAAA;AApMF;;AAuMA,kCAAA;AACA;EACE,mBAAA;EAEA,aAAA;EACA,uBAAA;EAEA,UAAA;EACA,gBAAA;EAEA,6DACE;AAxMJ;;AA4MA;EACE,uBAAA;EACA,UAAA;AAzMF;;AA4MA;EACE,uBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;AAzMF;;AA4MA,wBAAA;AACA;EACE,mBAAA;EAEA,aAAA;EACA,gBAAA;EAEA,0BAAA;EACA,kBAAA;AA3MF;;AA8MA;EACE,YAAA;AA3MF;;AA8MA;;8DAAA;AAIA;EACE;IACE,mBAAA;EA5MF;EA+MA;IACE,gBAAA;IACA,4BAAA;EA7MF;AACF","sourcesContent":["// .collapse-card {\n//   --collapse-accent: #88b6f2;\n\n//   position: relative;\n//   border-radius: var(--radius, 8px);\n//   overflow: hidden;\n//   min-width: 0;\n\n//   /* FIX: force white instead of inheriting ambient blue background */\n//   background: #ffffff;\n\n//   transition:\n//     box-shadow 150ms ease,\n//     transform 150ms ease;\n// }\n\n// /* ---- LEFT ACCENT BAR ---- */\n// .collapse-card::before {\n//   content: \"\";\n//   position: absolute;\n//   top: 0;\n//   bottom: 0;\n//   left: 0;\n//   width: 6px;\n//   background: var(--collapse-accent);\n//   border-radius: 10px 0 0 10px;\n//   z-index: 2;\n//   pointer-events: none;\n// }\n\n// /* ---- HOVER ---- */\n// .collapse-card:hover {\n//   box-shadow: 0 4px 14px rgba(136, 182, 242, 0.25);\n// }\n\n// .collapse-card:hover::before {\n//   background: var(--collapse-accent);\n// }\n\n// /* ---- HEADER ---- */\n// .collapse-card-header {\n//   background: #ffffff;\n//   min-height: 60px;\n//   display: flex;\n//   align-items: center;\n//   justify-content: space-between;\n//   gap: 12px;\n//   /* FIX: extra left padding so text/icons clear the 6px accent bar */\n//   padding: 12px 20px 12px 28px;\n//   cursor: pointer;\n//   user-select: none;\n//   position: relative;\n//   z-index: 1;\n// }\n\n// .collapse-card-header-right {\n//   display: flex;\n//   align-items: center;\n//   gap: 8px;\n// }\n\n// /* ---- TITLE ---- */\n// .collapse-card-title {\n//   flex: 1 1 auto;\n//   min-width: 0;\n// }\n\n// .collapse-card-title h5 {\n//   margin: 0;\n//   font-size: 17px;\n//   font-weight: 750;\n//   color: var(--navy);\n// }\n\n// /* ---- TOGGLE ICON ---- */\n// .collapse-card-icon {\n//   width: 32px;\n//   height: 32px;\n//   min-width: 32px;\n//   padding: 0;\n//   border: 0;\n//   background: transparent;\n//   display: flex;\n//   align-items: center;\n//   justify-content: center;\n//   color: var(--muted);\n//   cursor: pointer;\n//   transition:\n//     color 150ms ease,\n//     background 150ms ease;\n// }\n\n// .collapse-card-icon:hover {\n//   background: transparent;\n//   border-color: transparent;\n//   color: var(--collapse-accent);\n// }\n\n// .collapse-card-icon svg {\n//   transition: transform 0.28s ease;\n// }\n\n// .collapse-card.open .collapse-card-icon svg {\n//   transform: rotate(0deg);\n// }\n\n// .collapse-card:not(.open) .collapse-card-icon svg {\n//   transform: rotate(-90deg);\n// }\n\n// /* ---- COLLAPSIBLE CONTENT ---- */\n// .collapse-card-content {\n//   background: #ffffff;\n//   display: grid;\n//   grid-template-rows: 1fr;\n//   opacity: 1;\n//   overflow: hidden;\n//   transition:\n//     grid-template-rows 0.28s ease,\n//     opacity 0.22s ease;\n// }\n\n// .collapse-card.open .collapse-card-content {\n//   grid-template-rows: 1fr;\n//   opacity: 1;\n// }\n\n// .collapse-card:not(.open) .collapse-card-content {\n//   grid-template-rows: 0fr;\n//   opacity: 0;\n//   pointer-events: none;\n//   visibility: hidden;\n// }\n\n// .collapse-card-content > .card-body {\n//   background: #ffffff;\n//   min-height: 0;\n//   overflow: hidden;\n//   /* FIX: left padding so inner grid/cards clear the accent bar too */\n//   padding-left: 20px;\n// }\n\n// .collapse-card-content .row {\n//   min-width: 0;\n// }\n\n// /* ---- RESPONSIVE ---- */\n// @media (max-width: 760px) {\n//   .collapse-card-header {\n//     min-height: 60px;\n//     padding: 12px 14px 12px 24px;\n//   }\n//   .collapse-card-title h5 {\n//     font-size: 16px;\n//   }\n// }\n\n// @media (max-width: 520px) {\n//   .collapse-card-header {\n//     min-height: 56px;\n//     padding: 10px 11px 10px 22px;\n//   }\n//   .collapse-card-title h5 {\n//     font-size: 15px;\n//   }\n//   .collapse-card-icon {\n//     width: 30px;\n//     height: 30px;\n//     min-width: 30px;\n//   }\n// }\n\n// @media (max-width: 360px) {\n//   .collapse-card-header {\n//     padding-left: 18px;\n//     padding-right: 8px;\n//   }\n// }\n\n\n.btnActionGroup {\n  gap: 12px;\n}\n\n/* =========================================================\n   COLLAPSE CARD\n   ========================================================= */\n\n.collapse-card {\n  --collapse-accent: #88b6f2;\n\n  position: relative;\n  border-radius: var(--radius, 8px);\n  overflow: hidden;\n  min-width: 0;\n\n  /* Gap between each collapse bar */\n  margin-bottom: 20px;\n  margin-top: 14px;\n\n  /* Force white background */\n  background: #ffffff;\n  transition:\n    box-shadow 150ms ease,\n    transform 150ms ease;\n}\n\n/* Remove extra gap from the last collapse card */\n.collapse-card:last-child {\n  margin-bottom: 0;\n}\n\n/* ---- LEFT ACCENT BAR ---- */\n.collapse-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 6px;\n  background: var(--collapse-accent);\n  border-radius: 10px 0 0 10px;\n  z-index: 2;\n  pointer-events: none;\n}\n\n/* ---- HOVER ---- */\n.collapse-card:hover {\n  box-shadow: 0 4px 14px rgba(136, 182, 242, 0.25);\n}\n\n.collapse-card:hover::before {\n  background: var(--collapse-accent);\n}\n\n/* ---- HEADER ---- */\n.collapse-card-header {\n  background: #ffffff;\n  min-height: 60px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  gap: 12px;\n\n  /* Extra left padding for accent bar */\n  padding: 12px 20px 12px 28px;\n\n  cursor: pointer;\n  user-select: none;\n\n  position: relative;\n  z-index: 1;\n}\n\n/* ---- HEADER RIGHT ---- */\n.collapse-card-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ---- TITLE ---- */\n.collapse-card-title {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.collapse-card-title h5 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 750;\n  color: var(--navy);\n}\n\n/* ---- TOGGLE ICON ---- */\n.collapse-card-icon {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n\n  padding: 0;\n  border: 0;\n  background: transparent;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: var(--muted);\n  cursor: pointer;\n\n  transition:\n    color 150ms ease,\n    background 150ms ease;\n}\n\n.collapse-card-icon:hover {\n  background: transparent;\n  border-color: transparent;\n  color: var(--collapse-accent);\n}\n\n.collapse-card-icon svg {\n  transition: transform 0.28s ease;\n}\n\n.collapse-card.open .collapse-card-icon svg {\n  transform: rotate(0deg);\n}\n\n.collapse-card:not(.open) .collapse-card-icon svg {\n  transform: rotate(-90deg);\n}\n\n/* ---- COLLAPSIBLE CONTENT ---- */\n.collapse-card-content {\n  background: #ffffff;\n\n  display: grid;\n  grid-template-rows: 1fr;\n\n  opacity: 1;\n  overflow: hidden;\n\n  transition:\n    grid-template-rows 0.28s ease,\n    opacity 0.22s ease;\n}\n\n.collapse-card.open .collapse-card-content {\n  grid-template-rows: 1fr;\n  opacity: 1;\n}\n\n.collapse-card:not(.open) .collapse-card-content {\n  grid-template-rows: 0fr;\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n/* ---- CARD BODY ---- */\n.collapse-card-content > .card-body {\n  background: #ffffff;\n\n  min-height: 0;\n  overflow: hidden;\n\n  /* Clear left accent bar */\n  padding-left: 20px;\n}\n\n.collapse-card-content .row {\n  min-width: 0;\n}\n\n/* =========================================================\n   RESPONSIVE\n   ========================================================= */\n\n@media (max-width: 760px) {\n  .collapse-card {\n    margin-bottom: 12px;\n  }\n\n  .collapse-card-header {\n    min-height: 60px;\n    padding: 12px 16px 12px 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
